// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8572) return "js/8572.js";
	if (chunkId === 1275) return "js/1275.js";
	if (chunkId === 5086) return "js/5086.js";
	if (chunkId === 5300) return "js/5300.js";
	if (chunkId === 2135) return "js/2135.js";
	if (chunkId === 3424) return "js/3424.js";
	// return url for filenames based on template
	return undefined;
};